// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface SvixConfigOut {}

export const SvixConfigOutSerializer = {
  _fromJsonObject(_object: any): SvixConfigOut {
    return {};
  },

  _toJsonObject(_self: SvixConfigOut): any {
    return {};
  },
};
